module.exports = __webpack_public_path__ + "img/65727.7480463d.png";